import clsx from "clsx";
import styles from "../HowToWork.module.scss";
import { ZIC_OILS } from "../components/OilList";

export const distributorConfig = {
	greeting: "Здравствуйте, Дистрибьютор!",
	title: "Короткая инструкция по вашему личному кабинету",
	toc: [
		{ id: "s-01", title: "Авторизация" },
		{ id: "s-02", title: "Инструкция в видеоформате" },
		{ id: "s-03", title: "Основной раздел личного кабинета" },
		{ id: "s-04", title: "Раздел «Партнеры»" },
		{ id: "s-05", title: "Раздел «Торговые точки»" },
		{ id: "s-06", title: "Раздел «Заказ-наряды»" },
		{ id: "s-07", title: "Полные правила программы" },
		{ id: "s-08", title: "Задать вопрос" },
	],
	sections: [
		{
			id: "s-01",
			number: "01",
			title: "Авторизация",
			body: [
				{
					type: "p",
					children: (
						<>
							Авторизуйтесь, используя электронную почту, которую вы передавали
							для регистрации на портале. Это ваш логин. Пароль был отправлен на
							почту, отправитель —{" "}
							<span className={styles.borderText}>feedback@zictop.ru</span>.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/auth.png",
					mobileSrc: "/images/how_to_work/auth-mobile.png",
					alt: "Авторизация",
					width: 975,
				},
				{
					type: "alert",
					children: (
						<>
							Если пароль не пришёл или не сохранился, воспользуйтесь{" "}
							<span className={styles.borderText}>
								формой восстановления пароля
							</span>
							.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/password-recovery.png",
					mobileSrc: "/images/how_to_work/password-recovery-mobile.png",
					alt: "Форма восстановления пароля",
					width: 680,
				},
			],
		},

		{
			id: "s-02",
			number: "02",
			title: {
				node: (
					<>
						Воспользуйтесь{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/how-to-work-media"
						>
							инструкцией
						</a>{" "}
						в видеоформате. Или посмотрите описание ниже.
					</>
				),
			},
		},

		{
			id: "s-03",
			number: "03",
			title: {
				node: (
					<>
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account"
						>
							Основной раздел
						</a>{" "}
						личного кабинета
					</>
				),
			},
			body: [
				{
					type: "p",
					children:
						"Здесь вы можете отредактировать номер телефона и изменить свой пароль.",
				},
				{
					type: "image",
					src: "/images/how_to_work/editing-profile-distributor.png",
					mobileSrc:
						"/images/how_to_work/editing-profile-distributor-mobile.png",
					alt: "Редактирование профиля",
					width: 975,
				},
			],
		},

		{
			id: "s-04",
			number: "04",
			title: {
				node: (
					<>
						Раздел{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account/owners"
						>
							«Партнеры»
						</a>
					</>
				),
			},
			body: [
				{
					type: "p",
					children: (
						<>
							Партнер — представитель Торговой точки, в которой реализуется
							продукция ZIC. Как правило, Партнер — это хозяин Торговой точки
							(или сети магазинов / сервисов) или её представитель. За одним
							Партнером можно закрепить несколько Торговых точек.
						</>
					),
				},
				{
					type: "alert",
					children: (
						<p>
							<span className={styles.textBold}>Важно:</span> Партнер не может
							регистрировать чеки. Партнер регистрирует Торговые точки и
							Продавцов.
						</p>
					),
				},
				{
					type: "p",
					children: (
						<>
							В этом разделе вы можете посмотреть информацию о ваших Партнерах и
							добавить нового Партнера на портал. Для этого нажмите кнопку{" "}
							<span className={styles.textBold}>
								«Зарегистрировать Партнера ТТ».
							</span>
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/reg-partner-tt.png",
					mobileSrc: "/images/how_to_work/reg-partner-tt-mobile.png",
					alt: "Зарегистрировать Партнера ТТ",
					width: 975,
				},
				{
					type: "p",
					children: (
						<>
							Укажите необходимую информацию и нажмите{" "}
							<span className={styles.textBold}>«Зарегистрировать».</span>
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/modal-reg-partner-tt.png",
					mobileSrc: "/images/how_to_work/modal-reg-partner-tt-mobile.png",
					alt: "Модальное окно зарегистрировать",
					width: 680,
				},
				{
					type: "alert",
					children: (
						<>
							<p>
								На указанную в форме почту Партнер получит уведомление о
								регистрации на портале и свой пароль. Пожалуйста, заполняйте
								данные корректно. Вы не сможете их отредактировать после
								регистрации.
							</p>
							<br />
							<p>
								Если потребуется что-то изменить, вы можете обратиться к нам
								через форму обратной связи:{" "}
								<a className={styles.linkBorder} href="/feedback">
									https://zictop.ru/feedback
								</a>
								.
							</p>
						</>
					),
				},
			],
		},

		{
			id: "s-05",
			number: "05",
			title: {
				node: (
					<>
						Раздел{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account/sale-points"
						>
							«Торговые точки»
						</a>
					</>
				),
			},
			body: [
				{
					type: "image",
					src: "/images/how_to_work/retail-outlets.png",
					mobileSrc: "/images/how_to_work/retail-outlets-mobile.png",
					alt: "Торговые точки",
					width: 975,
				},
				{
					type: "p",
					children: (
						<>
							<p style={{ marginBottom: "20px" }}>
								Торговые точки — брендированные магазины или сервисы, в которых
								реализуется продукция ZIC. Зарегистрировать Торговую точку может
								Дистрибьютор или Партнер.
							</p>{" "}
							<p>
								Чтобы отправить заявку на регистрацию Торговой точки, нажмите
								кнопку{" "}
								<span className={styles.textBold}>
									«Зарегистрировать торговую точку»
								</span>{" "}
								и заполните данные в форме.
							</p>
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/application-registration.png",
					mobileSrc: "/images/how_to_work/application-registration-mobile.png",
					alt: "Заявка на регистрацию Торговой точки",
					width: 680,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>
							Вы сможете создать заявку только после добавления Партнера, так
							как Торговая точка прикрепляется к Партнеру.
						</>
					),
				},
				{
					type: "p",
					children: (
						<>
							После нажатия кнопки{" "}
							<span className={styles.textBold}>«Зарегистрировать»</span> придёт
							сообщение.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/succes-app-reg.png",
					mobileSrc: "/images/how_to_work/succes-app-reg-mobile.png",
					alt: "Заявка на регистрацию Торговой точки успешно отправлена",
					width: 680,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>
							Мы проверим, действительно ли Торговая точка существует и
							забрендирована, после чего активируем её на портале. Далее Партнер
							сможет добавить в неё Продавцов.
						</>
					),
				},
			],
		},

		{
			id: "s-06",
			number: "06",
			title: {
				node: (
					<>
						Раздел{" "}
						<a
							className={clsx(styles.linkBorder, styles.textSemibold)}
							href="/account/order"
						>
							«Заказ-наряды»
						</a>
					</>
				),
			},
			body: [
				{
					type: "alert",
					children: (
						<>
							Функционал становится доступным после согласия на обработку
							заказ-нарядов.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/order-of-work-orders.png",
					mobileSrc: "/images/how_to_work/order-of-work-orders-mobile.png",
					alt: "Заказ-наряды",
					width: 975,
					lazy: true,
				},
				{
					type: "p",
					children: (
						<>
							<p style={{ marginBottom: "20px" }}>
								Если вы ранее отказывались обрабатывать заказ-наряды, изменить
								решение можно в{" "}
								<a
									className={clsx(styles.linkBorder, styles.textSemibold)}
									href="/account"
								>
									Личном кабинете.
								</a>{" "}
							</p>
							<p style={{ marginBottom: "20px" }}>
								Чтобы отказаться от обработки заказ-нарядов, обратитесь в
								поддержку через{" "}
								<a
									className={clsx(styles.linkBorder, styles.textSemibold)}
									href="/feedback"
								>
									Форму обратной связи.
								</a>{" "}
							</p>
							<p style={{ marginBottom: "5px" }}>
								После согласия на обработку заказ-нарядов в меню появится
								вкладка{" "}
								<a
									className={clsx(styles.linkBorder, styles.textSemibold)}
									href="/account/order"
								>
									«Заказ-наряды».
								</a>
							</p>
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/work-orders-bar.png",
					mobileSrc: "/images/how_to_work/work-orders-bar-mobile.png",
					alt: "Навигация Заказ-наряды",
					width: 338,
					lazy: true,
				},
				{
					type: "p",
					children: (
						<>
							Вам будут поступать заказ-наряды от Продавцов на проверку. При
							поступлении заказ-наряда появится визуальное уведомление.
						</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/work-order-notification.png",
					mobileSrc: "/images/how_to_work/work-order-notification-mobile.png",
					alt: "Визуальное уведомление Заказ-наряды",
					width: 795,
					lazy: true,
				},
				{
					type: "p",
					children: (
						<>
							Необходимо сверить данные, предоставленные в заказ-наряде, с
							документами и информацией, которые есть у вас. Также проверьте на
							своей стороне, действительно ли продукт был реализован.
						</>
					),
				},
				{
					type: "oils",
					items: ZIC_OILS,
				},
				{
					type: "alert",
					children: (
						<>
							В акции участвуют заказ-наряды с продажами не ранее 01.04.2026,
							которые ранее не были загружены на сайт. Дубли будут исключены из
							акции.
						</>
					),
				},
				{
					type: "p",
					children:
						"После проверки вы подтверждаете или отклоняете позиции в заказ-наряде.",
				},
				{
					type: "image",
					src: "/images/how_to_work/checking-work-order.png",
					mobileSrc: "/images/how_to_work/checking-work-order-mobile.png",
					alt: "Проверка заказ-наряда",
					width: 975,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>При отклонении обязательно необходимо указать причину отказа.</>
					),
				},
				{
					type: "image",
					src: "/images/how_to_work/reject-work-order.png",
					mobileSrc: "/images/how_to_work/reject-work-order-mobile.png",
					alt: "Причина отклонения заказ-наряда",
					width: 424,
					lazy: true,
				},
				{
					type: "alert",
					children: (
						<>
							Проверка проводится в течение 5 (пяти) рабочих дней с момента
							поступления Заказ-наряда в личный кабинет Дистрибьютора.
						</>
					),
				},
			],
		},

		{
			id: "s-07",
			number: "07",
			title: {
				before: "Полные",
				link: { label: "правила", dynamicRules: true },
				after: "программы. Их можно найти в меню Личного кабинета.",
			},
			body: [
				{
					type: "image",
					src: "/images/how_to_work/rule-menu.png",
					mobileSrc: "/images/how_to_work/rule-menu-mobile.png",
					alt: "Полные правила программы, можно найти в меню Личного кабинета",
					width: 338,
					lazy: true,
				},
			],
		},

		{
			id: "s-08",
			number: "08",
			title: {
				before: "Задать вопросы можно через форму обратной связи",
				link: { label: "https://zictop.ru/feedback", href: "/feedback" },
				after: ".",
			},
		},
	],
};
